<template>
  <div>
    <b-card-group deck>
      <b-card no-body class="card-profile mt-6" v-for="(leader, key) in leaders" :key="key">
        <b-row class="justify-content-center">
          <b-col class="order-lg-2 text-center">
            <div class="mt--6">
              <avatar :variant="'secondary'" :name="leader.agents" :avatar="leader.avatar" :size="'9rem'" :border="true" :class="'border-gold'" v-if="key == 0"></avatar>
              <avatar :variant="'secondary'" :name="leader.agents" :avatar="leader.avatar" :size="'9rem'" :border="true" :class="'border-silver'" v-if="key == 1"></avatar>
              <avatar :variant="'secondary'" :name="leader.agents" :avatar="leader.avatar" :size="'9rem'" :border="true" :class="'border-bronze'" v-if="key == 2"></avatar>
            </div>
            <div class="fa-stack mt--4 text-center">
              <i class="fas fa-circle fa-stack-2x text-gold" v-if="key == 0"></i>
              <i class="fas fa-1 fa-stack-1x text-white" v-if="key == 0"></i>
              <i class="fas fa-circle fa-stack-2x text-silver" v-if="key == 1"></i>
              <i class="fas fa-2 fa-stack-1x text-white" v-if="key == 1"></i>
              <i class="fas fa-circle fa-stack-2x text-bronze" v-if="key == 2"></i>
              <i class="fas fa-3 fa-stack-1x text-white" v-if="key == 2"></i>
            </div>
          </b-col>
        </b-row>
        <b-card-body>
          <div class="text-center">
            <h3>{{ leader.agents }}</h3>
            <h4 v-if="['pending_volume', 'closed_volume', 'total_volume'].includes(sortBy)">{{ leader[sortBy] | currency }} {{ label }}</h4>
            <h4 v-else>{{ leader[sortBy] }} {{ label }}</h4>
          </div>
        </b-card-body>
      </b-card>
    </b-card-group>
    <b-card no-body>
      <b-card-header>
        <div class="d-flex justify-content-between">
          <h3>Sales Leaderboard</h3>
          <b-link href="/leaderboards/sales" target="_blank"><i class="fa-solid fa-up-right-and-down-left-from-center" v-if="!$route.params.active"></i></b-link>
        </div>
        <b-row>
          <b-col md="8">
            <div>
              <label class="form-control-label">Date Range</label>
              <b-input-group>
                <template #prepend>
                  <b-dropdown variant="outline-danger">
                    <template #button-content>
                      {{ rangeTitle }}
                    </template>
                    <b-dropdown-item v-for="item in ranges" :key="item.value" @click="range = item.value">{{ item.label }}</b-dropdown-item>
                  </b-dropdown>
                </template>
                <b-form-datepicker v-model="start_date" locale="en" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
                <b-form-datepicker v-model="end_date" locale="en" :min="start_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
              </b-input-group>
            </div>
          </b-col>
          <b-col md="4">
            <base-input label="Active Members" label-for="active">
              <base-switch class="mr-1" v-model="active"></base-switch>
            </base-input>
          </b-col>
        </b-row>
      </b-card-header>
      <loading-panel v-if="loading"></loading-panel>
      <b-table id="production-report" responsive small :items="sales" :fields="columns" no-sort-reset :sort-by.sync="sortBy" :sort-desc.sync="sortDir" v-else>
        <template #head(pending_units)="row">
          Pending Units
        </template>
        <template #head(pending_volume)="row">
          Pending Volume
        </template>
        <template #head(closed_units)="row">
          Closed Units
        </template>
        <template #head(closed_volume)="row">
          Closed Volume
        </template>
        <template #head(total_units)="row">
          Total Units
        </template>
        <template #head(total_volume)="row">
          Total Volume
        </template>
        <template #cell(place)="row">
          <span v-if="row.index + 1 == 1">
            <i class="fa-solid fa-award fa-3x text-gold"></i>
          </span>
          <span v-else-if="row.index + 1 == 2">
            <i class="fa-solid fa-award fa-3x text-silver"></i>
          </span>
          <span v-else-if="row.index + 1 == 3">
            <i class="fa-solid fa-award fa-3x text-bronze"></i>
          </span>
          <span v-else>
            <span style="font-size: 18px;">{{ row.index + 1 }}</span>
          </span>
        </template>
        <template #cell(agents)="row">
          <avatar :variant="'danger'" :name="row.item.agents" :avatar="row.item.avatar"></avatar>
        </template>
        <template #cell(pending_volume)="row">
          {{ row.item.pending_volume | currency }}
        </template>
        <template #cell(closed_volume)="row">
          {{ row.item.closed_volume | currency }}
        </template>
        <template #cell(total_volume)="row">
          {{ row.item.total_volume | currency }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import LoadingPanel from '@/components/LoadingPanel';
import { Select, Option } from 'element-ui';
import columns from './columns';
import Avatar from '@/views/Components/Avatar';
export default {
  props: {
    userRoute: null
  },
  components: {
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    Avatar
  },
  data() {
    return {
      sales: [],
      active: true,
      team: [],
      start_date: new Date(new Date().getFullYear(), 0, 1),
      end_date: new Date(new Date().getFullYear(), 11, 31),
      range: 0,
      ranges: [
        { value: 0, label: "Current Year" },
        { value: 1, label: "Yesterday" },
        { value: 2, label: "Last 7 Days" },
        { value: 3, label: "Current Month" },
        { value: 4, label: "Last 3 Months" },
      ],
      loading: false,
      columns: columns,
      sortBy: 'total_volume',
      sortDir: true,
      leaders: [],
    }
  },
  computed: {
    rangeTitle() {
      return this.ranges.filter((item) => {
        return item.value == this.range;
      })[0].label;
    },
    visibleColumns() {
      return this.columns.filter(field => field.visible)
    },
    label() {
      let labelArray = this.sortBy.split("_");
      let labelArray2 = labelArray.map(function(x){ return x[0].toUpperCase() + x.slice(1); });
      return labelArray2.join(" ");
    }
  },
  methods: {
    async getSalesLeaderboard() {
      this.loading = true;
      let startDate = new Date(this.start_date).toLocaleDateString("en-US");
      let endDate = new Date(this.end_date).toLocaleDateString("en-US");
      const active = this.active ? 1 : 0;

      await axios.get(this.userRoute + "/leaderboards?type=sales&start_date=" + startDate + "&end_date=" + endDate + "&active=" + active + "&sortBy=" + this.sortBy)
      .then(response => {
        this.sales = response.data;
        this.leaders = this.sales.slice(0, 3);
        this.loading = false;
      })
      .catch(error => {

      });
    },
    initials(agent) {
      let initials = agent.split(" ");

      if (initials.length > 1) {
        return initials[0].charAt(0) + initials[1].charAt(0);
      }

      return initials[0].charAt(0);
    },
    updateRange() {
      switch(this.range) {
        case 0:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
          break;
        case 1:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 1))
          this.start_date = start_date;
          this.end_date = start_date;
          break;
        case 2:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 7))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 3:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - date.getDate() + 1))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 4:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 84))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        default:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
      }
    },
  },
  created() {
    this.getSalesLeaderboard();
  },
  watch: {
    range(to, from) {
      this.updateRange();
    },
    start_date(to, from) {
      this.getSalesLeaderboard();
    },
    end_date(to, from) {
      this.getSalesLeaderboard();
    },
    active(to, from) {
      this.getSalesLeaderboard();
    }
  }
}
</script>
<style lang="scss">
.bg-clarity {
  background-color: #3D5F71 !important;
}
.text-gold {
  color: #D4AF37;
}
.border-gold {
  border: 5px solid #D4AF37 !important;
}
.text-silver {
  color: #999B9B;
}
.border-silver {
  border: 5px solid #999B9B !important;
}
.text-bronze {
  color: #CE8946;
}
.border-bronze {
  border: 5px solid #CE8946 !important;
}
</style>